import { useEffect } from "react";

/**
 * Activates the global `.reveal` → `.is-visible` scroll fade-in.
 * Mount once on a page (e.g., from the Landing root). Idempotent.
 */
export default function useScrollReveal(rootSelector = "[data-reveal-root]") {
  useEffect(() => {
    if (typeof window === "undefined" || !("IntersectionObserver" in window)) return;
    const root = document.querySelector(rootSelector) || document;
    const els = root.querySelectorAll(".reveal:not(.is-visible)");
    if (!els.length) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            obs.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.08 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [rootSelector]);
}
